export interface UserTypeConfig {
  label: string;
  color: 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
  avatarColor: string;
  isAdmin: boolean;
}

export const USER_TYPE_MAP: Record<string, UserTypeConfig> = {
  '01': {
    label: 'Super Admin',
    color: 'error',
    avatarColor: 'error.main',
    isAdmin: true,
  },
  '02': {
    label: 'Client Admin',
    color: 'primary',
    avatarColor: 'primary.main',
    isAdmin: true,
  },
  '03': {
    label: 'Region Admin',
    color: 'primary',
    avatarColor: 'primary.main',
    isAdmin: true,
  },
  '04': {
    label: 'Project Admin',
    color: 'primary',
    avatarColor: 'primary.main',
    isAdmin: true,
  },
  '05': {
    label: 'Client Viewer',
    color: 'secondary',
    avatarColor: 'secondary.main',
    isAdmin: false,
  },
  '06': {
    label: 'Region Viewer',
    color: 'secondary',
    avatarColor: 'secondary.main',
    isAdmin: false,
  },
  '07': {
    label: 'Project Viewer',
    color: 'secondary',
    avatarColor: 'secondary.main',
    isAdmin: false,
  },
  '11': {
    label: 'Calibration Admin',
    color: 'primary',
    avatarColor: 'primary.main',
    isAdmin: true,
  },
  '99': {
    label: 'Specialised User',
    color: 'warning',
    avatarColor: 'warning.main',
    isAdmin: false,
  },
};

/**
 * Get the display label for a user type
 */
export const getUserTypeLabel = (userType: string): string => {
  return USER_TYPE_MAP[userType]?.label || userType;
};

/**
 * Get the chip color for a user type
 */
export const getUserTypeColor = (userType: string): UserTypeConfig['color'] => {
  return USER_TYPE_MAP[userType]?.color || 'default';
};

/**
 * Get the avatar background color for a user type
 */
export const getUserTypeAvatarColor = (userType: string): string => {
  return USER_TYPE_MAP[userType]?.avatarColor || 'secondary.main';
};

/**
 * Check if a user type is an admin role
 */
export const isAdminUserType = (userType: string): boolean => {
  return USER_TYPE_MAP[userType]?.isAdmin || false;
};

/**
 * Get all user types as an array for dropdowns/selects
 */
export const getAllUserTypes = (): Array<{ value: string; label: string; config: UserTypeConfig }> => {
  return Object.entries(USER_TYPE_MAP).map(([value, config]) => ({
    value,
    label: config.label,
    config,
  }));
};

/**
 * Check if user type is Super Admin
 */
export const isSuperAdminType = (userType: string): boolean => {
  return userType === '01';
};

/**
 * Get user types by category
 */
export const getUserTypesByCategory = () => {
  const admins = getAllUserTypes().filter(type => type.config.isAdmin);
  const viewers = getAllUserTypes().filter(type => !type.config.isAdmin);
  
  return {
    admins,
    viewers,
    all: getAllUserTypes(),
  };
};
